module.exports = [{"class":"totally-agree","name":"totallyAgree","description":"Helemaal mee eens","value":"10"},{"class":"agree","name":"agree","description":"Mee eens","value":"8"},{"class":"neutral","name":"neutral","description":"Niet mee eens, niet mee oneens","value":"6"},{"class":"disagree","name":"disagree","description":"Mee oneens","value":"4"},{"class":"totally-disagree","name":"totallyDisagree","description":"Helemaal mee oneens","value":"2"}]


//////////////////
// WEBPACK FOOTER
// ./data/answers.emotions.json
// module id = 47
// module chunks = 0